import { FormTitle, FormTitleDescription, FormSection } from '../base';

export const FormHeaderSection = ({
  children,
  title
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return (
    <FormSection>
      <FormTitle>{title}</FormTitle>
      <FormTitleDescription>{children}</FormTitleDescription>
    </FormSection>
  );
};
